import redirectHelper from '../../Utils/redirectHelper';

import template from './unknownUser.html';

export function UnknownUserViewModel() {
  const self = this;

  self.logout = function () {
    redirectHelper.logoutRedirect();
  };
}

// The default export returns the component details object to register with KO
export default { viewModel: UnknownUserViewModel, template: template };
